<template>
  <div class="wrapper">
    <div class="nav">
      <div class="nav-item rollIn" :class="item.isM && 'navWOW'" data-wow-duration="0.8s" :data-wow-delay="index * 0.1 + 's'"
        v-for="(item, index) in nav" :style="activePath == item.path ? 'color:' + item.color : ''" @click="navClick(item)"
        :key="index">{{ item.name }}</div>
    </div>
    <div class="userName flex fd-c">
      <div class="t1 nameWOW flipInY" data-wow-duration="3s" data-wow-delay="0s">石 佳韵</div>
      <div class="t2 nameWOW flipInY" data-wow-duration="3s" data-wow-delay="0s">SHI JIAYUN</div>
    </div>
    <!-- <div class="ba">{{info.copyright}}</div> -->
    <router-view></router-view>
    <div class="kong"></div>
    <div class="txt-box flex ai-c" v-if="info.email">
      <div class="txt" @click="emailClick">EMAIL</div>
      <div class="txt" @click="instagram">INSTAGRAM</div>
      <div class="txt">{{ info.copyright }}</div>
    </div>
  </div>
</template>

<script>
import { site } from '../../api'

export default {
  components: {},
  props: {},
  data() {
    return {
      nav: [{
        name: 'WORKS',
        color: 'rgba(0, 0, 255, 1)',
        path: '/pc/works',
        isM: true
      }, {
        name: 'NEWS',
        color: 'rgba(147, 39, 143, 1)',
        path: '/pc/news',
        isM: true
      }, {
        name: 'EXHIBITIONS',
        color: 'rgba(0, 113, 188, 1)',
        path: '/pc/exhibitions',
        isM: true
      }, {
        name: 'TEXTS',
        color: 'rgb(238,68,38)',
        path: '/pc/texts',
        isM: true
      }, {
        name: 'BIOGRAPHY',
        color: 'rgba(34, 181, 115, 1)',
        path: '/pc/biography',
        isM: true
      }],
      activePath: '',
      info: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    navClick(item) {
      if (this.activePath == item.path) { return }
      for (var im of this.nav) {
        im.isM = false
      }
      item.isM = true
      this.activePath = item.path
      this.$router.push({ path: item.path })
      setTimeout(() => {
        this.$wow('navWOW')
      }, 10)

    },
    site() {
      site({}).then(res => {
        this.info = JSON.parse(res.data.data)
        localStorage.setItem('siteInfo', res.data.data)
      })
    },
    emailClick() {
      window.open('mailto:' + this.info.email)
    },
    instagram() {
      window.open(this.info.inslink)
    }
  },
  created() {
    this.site()
    this.activePath = this.$route.path
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow('navWOW')
      this.$wow('nameWOW')
    })

  }
}
</script>
<style scoped>
.wrapper {
  position: relative;
  min-height: 100vh;
  height: 100%;
}

@media screen and (max-width: 1366px) {
  /* .wrapper{
    width: calc(100% - 8px);
  } */
  /* .nav,.txt-box{
      left: 0!important;
  }
  .userName{
      right: 0!important;
  }
  .ba{
      right: 20px!important;
  } */
}

.nav {
  position: fixed;
  /* left: calc(50% - 683px); */
  left: 20px;
  top: 20px;
  /* margin-left: 38px; */
  z-index: 100;
}

.nav-item {
  font-size: 14px;
  line-height: 16px;
  font-family: KhmerSangamMN;
  font-weight: 400;
  color: #000000;
  margin-bottom: 10px;
  cursor: pointer;
}

.userName {
  position: fixed;
  /* right: calc(50% - 683px); */
  right: 20px;
  top: 20px;
  /* margin-right: 40px; */
  z-index: 100;
}

.userName .t1 {
  font-size: 19px;
  line-height: 21px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: #000000;
}

.userName .t2 {
  font-size: 14px;
  line-height: 16px;
  font-family: KhmerSangamMN;
  font-weight: 400;
  color: #000000;
  margin-top: 4px;
}

.ba {
  position: fixed;
  z-index: 1000;
  /* right: calc(50% - 648px); */
  right: 20px;
  bottom: 0px;
  transform: rotate(90deg);
  transform-origin: top right;
  font-family: KhmerSangamMN;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.txt-box {
  position: fixed;
  width: 100%;
  z-index: 100;
  left: 0px;

  bottom: 0;
  padding: 15px 0;
  background-color: #fff;
}

.txt-box .txt {
  font-size: 14px;
  font-family: KhmerSangamMN;
  font-weight: 400;
  color: #000000;
  line-height: 16px;
  cursor: pointer;
  margin-left: 30px;
}

.txt-box .txt:nth-child(1) {
  margin-left: 20px;
}

.kong {
  width: 100%;
  min-height: 120px;
}</style>